import { action, computed, makeObservable, observable } from 'mobx';
import { BaseVM } from './BaseVM';
import { Bucket } from '../interfaces/Bucket';
import { normalizing } from '../helpers/normalizing';
import { getTransformer, handler, makeMetadata, property } from '../helpers/decorators';

export class InputVM extends BaseVM {
  constructor(...args: any[]) {
    super(...args);
    makeObservable(this);
    makeMetadata(this);
  }

  /**
   * @hidden
   * @protected
   */
  @observable.shallow
  protected _VALUE_ = new Bucket();

  /**
   * @hidden
   * @protected
   */
  @observable.shallow
  protected _DEFAULT_VALUE_ = new Bucket();

  @property
  @computed
  get value(): any {
    return getTransformer(this, 'valueGetter')(this._VALUE_.value);
  }

  set value(value: any) {
    this._VALUE_.value = getTransformer(this, 'valueSetter')(value);
  }

  /**
   * 更新当前VM的value信息
   * @param value
   */
  @action
  setValue(value: any): this {
    this.value = value;
    return this;
  }

  /**
   * @hidden
   */
  @computed
  get $form() {
    return this.$upper('FORM');
  }

  /**
   * @hidden
   */
  @action
  $linkToUpper(upper?: InputVM, refKey?: string, defaultValue?: any) {
    if (upper && refKey !== undefined) {
      this._VALUE_.link(upper, 'value', refKey);
      this._DEFAULT_VALUE_.link(upper, 'defaultValue', refKey);
    }

    // VM 相关逻辑修正
    // 为了保持在没有触发`Form`的`Change`事件时候同步值到`value`
    // 使得表单保存的值与VM值的等同
    if (defaultValue !== undefined) {
      this.defaultValue = defaultValue;
      if (this.value === undefined) {
        this.value = defaultValue;
      }
    }
  }

  @property
  @computed
  get defaultValue(): any {
    return getTransformer(this, 'valueGetter')(this._DEFAULT_VALUE_.value);
  }

  set defaultValue(value: any) {
    this._DEFAULT_VALUE_.value = getTransformer(this, 'valueSetter')(value);
  }

  @action
  setDefaultValue(value: any) {
    this.defaultValue = value;
  }

  @handler
  @action
  onChange(e: any) {
    this.setValue(normalizing(e));
  }
}
